import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

export default function SaleReport({ creditDatas }) {
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({});
  const screenWidth = window.innerWidth;
  const isMobile = screenWidth < 768;
  useEffect(() => {
    if (creditDatas && creditDatas?.chartDatas) {
      getChartData(creditDatas?.chartDatas);
    }
  }, [creditDatas]);

  const getChartData = (transactions) => {
    
    // Initialize an object to store the sums for each hour from 1:00 AM to 12:00 AM
    const hourlySums = {};
    for (let i = 1; i <= 12; i++) {
      hourlySums[i] = 0;
    }

    // Group and sum the amounts by hour
    transactions.forEach(transaction => {
      const date = new Date(transaction?.paymentTime);
      const hour = (date.getHours() % 12) + 1; // Get hour from 1 to 12 (AM)
      hourlySums[hour] += transaction?.amount;
    });

    // Prepare the data for ApexCharts
    setOptions({
      chart: {
        fontFamily: "FontLao2",
        id: "sales-chart",
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        categories: Object.keys(hourlySums).map(hour => `${hour}:00 AM`), // X-axis labels as hours
        labels: {
          style: {
            fontSize: '14px',
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            fontSize: '14px',
          },
        },
      },
      fill: {
        colors: ["#2F539B"],
      },
      plotOptions: {
        bar: {
          borderRadius: 1,
          horizontal: false,
        },
      },
      dataLabels: {
        enabled: true,
      },
      tooltip: {
        theme: 'dark',
      },
    });

    setSeries([
      {
        name: "ຍອດຂາຍລາຍຊົ່ວໂມງ", // Y-axis label (Hourly Sales)
        data: Object.keys(hourlySums).map(hour => hourlySums[hour]),
      },
    ]);
  };

  if (series.length === 0) return null;

  return (
    <div>
      <Chart
        options={options}
        series={series}
        type="bar"
        width="100%"
        height={isMobile ? "315px" : "515px"}
      />
    </div>
  );
}
